import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRainbow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRainbow"><Path fillRule="evenodd" clipRule="evenodd" d="M12 8C6.47715 8 2 12.4772 2 18H0C0 11.3726 5.37258 6 12 6C18.6274 6 24 11.3726 24 18H22C22 12.4772 17.5228 8 12 8ZM12 12C8.68629 12 6 14.6863 6 18H4C4 13.5817 7.58172 10 12 10C16.4183 10 20 13.5817 20 18H18C18 14.6863 15.3137 12 12 12ZM12 16C10.8954 16 10 16.8954 10 18H8C8 15.7909 9.79086 14 12 14C14.2091 14 16 15.7909 16 18H14C14 16.8954 13.1046 16 12 16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRainbow;
